module.exports = __webpack_public_path__ + "89b8d44f93f1174dca11c430ad0142db.png";